export default "__VITE_ASSET__BXcOjMng__"